import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import Loading from 'Components/ScopedLoader';
import { actions as deviceActions } from 'ducks/devices';
import { loadSite } from 'ducks/loadSite';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { HEADER_HEIGHT } from 'utils/ui/constants';
import Device from './Device';
import Site from './Site';
import SiteList from './SiteList';
import Tree from './Tree';

const LeftContainer = styled(Grid)(({ theme }) => ({
    height: `calc(100vh - ${HEADER_HEIGHT}px)`,
    backgroundColor: theme.palette.backgrounds.color.main
}));

const RightContainer = styled(Grid)(() => ({
    height: `calc(100vh - ${HEADER_HEIGHT}px)`
}));

const Component = () => {
    const {
        deviceId: ParamDeviceId,
        section,
        siteId: ParamSiteId
    } = useParams();

    const mode = ParamDeviceId ? 'device' : 'site';
    const device = useSelector(state => state.devices.models[ParamDeviceId]);
    const siteId = mode === 'site' ? ParamSiteId : (device && device.site_id);
    const deviceId = mode === 'site' ? null : ParamDeviceId;
    const panelOpen = useSelector(state => state.ui.showSites);
    const validSite = useSelector(state => mode === 'site' ? !!state.sites.models[ParamSiteId] : !!state.sites.models[siteId]);
    const loaded = useSelector(state => mode === 'site' ? state.loadedSites[ParamSiteId] : state.loadedSites[siteId]);
    const validDevice = mode === 'site' ? null : !!device;

    const dispatch = useDispatch();

    useEffect(() => {
        if (mode === 'site' && !loaded) {
            dispatch(loadSite(siteId));
        } else if (mode === 'device' && !validDevice) {
            dispatch(deviceActions.fetchOne(deviceId));
        } else if (mode === 'device' && !loaded) {
            dispatch(loadSite(siteId));
        }
    }, [deviceId, dispatch, loaded, mode, siteId, validDevice]);

    if (!loaded) {
        return <Loading/>;
    }

    if (!validSite) {
        return <div>Invalid site</div>;
    }

    if (deviceId && !validDevice) {
        return <div>Invalid device</div>;
    }

    let tree = <Tree deviceId={deviceId} siteId={siteId}/>;
    if (panelOpen) {
        tree = null;
    }

    const Container = deviceId ?
        <Device deviceId={deviceId} section={section}/> :
        <Site section={section} siteId={siteId}/>;

    return (
        <>
            <LeftContainer size={3}>
                <SiteList siteId={siteId}/>
                {tree}
            </LeftContainer>
            <RightContainer size={9}>
                {Container}
            </RightContainer>
        </>
    );
};

export default Component;
